import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IReleasedProductSourcingVendor {
    vendorAccountNumber: string;
    dataAreaId: string;
    vendorName: string;
    /** "Known as" display name — preferred over vendorName which can be blank from D365. */
    vendorKnownAsName: string;
    vendorPartyNumber: string;
    vendorGroupId: string;
    addressCountryRegionId: string;
    /** ISO 3166-1 alpha-2 — drives the vendor country flag in the explorer. */
    addressCountryRegionISOCode: string;
    addressCity: string;
    isIntercompany: boolean;
    intercompanyDataAreaIds: string[];
}

export interface IReleasedProductSourcing {
    itemNumber: string;
    dataAreaId: string;
    defaultOrderType: string;
    primaryVendorAccountNumber: string | null;
    vendor: IReleasedProductSourcingVendor | null;
}

export const getReleasedProductSourcingD365 = async (
    itemNumber: string,
    dataAreaId: string,
): Promise<IReleasedProductSourcing | null> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IReleasedProductSourcing>(
        `/ReleasedProduct/GetReleasedProductSourcingD365`,
        { params: { itemNumber, dataAreaId } },
    );
    return response.status === 204 || !response.data ? null : response.data;
};
